import React, { Fragment, useEffect, useState } from 'react'
import { Card, Row, Col, message, Modal, Form, Spin, Radio, Slider } from 'antd'
import { ImageSelect } from '../../Form'
import './AiTemplateSelection.scss'
import { BlockPicker } from 'react-color'

import template1 from '../../../assets/courseTemplates/template-1.png'
import template3 from '../../../assets/courseTemplates/template-3.png'
import template4 from '../../../assets/courseTemplates/template-4.png'
import { useTranslation } from 'react-i18next'

const colors = [
  '#F8F9FA',
  '#E9ECEF',
  '#DEE2E6',
  '#CED4DA', // Light Neutrals
  '#FFF8E1',
  '#FFF3E0',
  '#E8F5E9',
  '#E3F2FD', // Light Pastels
  '#FFEBEE',
  '#FFCDD2',
  '#EDE7F6', // More Light Pastels
  '#FCE4EC',
  '#F3E5F5',
  '#EDE7F6',
  '#E8F5E9', // Subtle Colors
  '#FBE9E7',
  '#FFFDE7',
  '#F1F8E9', // Soft Muted Tones
  '#D9E3F0',
  '#F47373',
  '#697689',
  '#37D67A',
  '#2CCCE4',
  '#555555',
  '#DCE775',
  '#FF8A65',
  '#BA68C8',
  '#FFB74D'
]

// Static template data - defined outside component
const STATIC_TEMPLATES = [
  {
    template_id: 1,
    content_id: 1416981,
    template: template1,
    template_data: [
      {
        uid: null,
        type: 'BACKGROUND_COLOR',
        params: {
          content: null
        }
      },
      {
        uid: null,
        type: 'BACKGROUND_IMAGE',
        params: {
          content: null,
          content_id: null,
          opacity: 1
        }
      },
      {
        uid: null,
        type: 'IMAGE',
        display: 'LOGO',
        tstyle: 1,
        params: {
          content: null,
          width: 164,
          height: 61,
          x: 425,
          y: 463,
          content_id: null
        }
      },
      {
        uid: null,
        type: 'TEXT',
        display: 'HEADING',
        tstyle: 1,
        params: {
          content:
            '<p><strong style="font-size: 36px;">SubTopic_Placeholder</strong></p>',
          width: 975,
          height: 112,
          x: 24,
          y: 52,
          media_format: 'TEXT'
        }
      },
      {
        uid: null,
        type: 'TEXT',
        display: 'CONTENT',
        params: {
          content:
            '<p class="ql-align-left"><span style="font-size: 16px;">Generated_Content_Placeholder</span></p>',
          width: 977,
          height: 284,
          x: 23,
          y: 204,
          media_format: 'TEXT'
        }
      },
      {
        uid: null,
        type: 'TEXT',
        display: 'SUB_CONTENT',
        params: {
          content:
            '<p class="ql-align-left"><span style="font-size: 16px;">Generated_Content_Placeholder</span></p>',
          width: 460,
          height: 284,
          x: 23,
          y: 204,
          media_format: 'TEXT'
        }
      },
      {
        uid: null,
        type: 'IMAGE',
        display: 'IMAGE',
        params: {
          content: null,
          width: 460,
          height: 284,
          x: 507,
          y: 204,
          content_id: null
        }
      }
    ]
  },

  {
    template_id: 2,
    content_id: 1416983,
    template: template3,
    template_data: [
      {
        uid: null,
        type: 'BACKGROUND_COLOR',
        params: {
          content: null
        }
      },
      {
        uid: null,
        type: 'BACKGROUND_IMAGE',
        auto: false,
        params: {
          opacity: 1,
          content: null,
          content_id: null
        }
      },
      {
        uid: null,
        type: 'TEXT',
        display: 'CONTENT',
        params: {
          content:
            '<p class="ql-align-left"><span style="font-size: 16px;">Generated_Content_Placeholder</span></p>',
          width: 943,
          height: 393,
          x: 42,
          y: 221,
          media_format: 'TEXT'
        }
      },
      {
        uid: null,
        type: 'TEXT',
        display: 'HEADING',
        tstyle: 3,
        params: {
          content:
            '<p><strong style="font-size: 36px;">SubTopic_Placeholder</strong></p>',
          width: 569,
          height: 124,
          x: 42,
          y: 49,
          media_format: 'TEXT'
        }
      },
      {
        uid: null,
        type: 'IMAGE',
        display: 'LOGO',
        tstyle: 3,
        params: {
          content: null,
          width: 156,
          height: 67,
          x: 822,
          y: 48,
          content_id: null
        }
      },
      {
        uid: null,
        type: 'TEXT',
        display: 'SUB_CONTENT',
        params: {
          content:
            '<p class="ql-align-left"><span style="font-size: 16px;">Generated_Content_Placeholder</span></p>',
          width: 460,
          height: 393,
          x: 42,
          y: 221,
          media_format: 'TEXT'
        }
      },
      {
        uid: null,
        type: 'IMAGE',
        display: 'IMAGE',
        params: {
          content: null,
          width: 460,
          height: 393,
          x: 526,
          y: 221,
          content_id: null
        }
      }
    ]
  },
  {
    template_id: 3,
    content_id: 1416984,
    template: template4,
    template_data: [
      {
        uid: null,
        type: 'BACKGROUND_COLOR',
        params: {
          content: null
        }
      },
      {
        uid: null,
        type: 'BACKGROUND_IMAGE',
        auto: false,
        params: {
          opacity: 1,
          content: null,
          content_id: null
        }
      },
      {
        uid: null,
        type: 'TEXT',
        display: 'HEADING',
        tstyle: 4,
        params: {
          content:
            '<p class="ql-align-right"><strong style="font-size: 36px;">SubTopic_Placeholder</strong></p>',
          width: 579,
          height: 118,
          x: 423,
          y: 60,
          media_format: 'TEXT'
        }
      },
      {
        uid: null,
        type: 'IMAGE',
        display: 'LOGO',
        tstyle: 4,
        params: {
          content: null,
          width: 143,
          height: 59,
          x: 29,
          y: 61,
          content_id: null
        }
      },
      {
        uid: null,
        type: 'TEXT',
        display: 'CONTENT',
        params: {
          content:
            '<p class="ql-align-left"><span style="font-size: 16px;">Generated_Content_Placeholder</span></p>',
          width: 972,
          height: 400,
          x: 29,
          y: 211,
          media_format: 'TEXT'
        }
      },
      {
        uid: null,
        type: 'TEXT',
        display: 'SUB_CONTENT',
        params: {
          content:
            '<p class="ql-align-left"><span style="font-size: 16px;">Generated_Content_Placeholder</span></p>',
          width: 460,
          height: 400,
          x: 29,
          y: 211,
          media_format: 'TEXT'
        }
      },
      {
        uid: null,
        type: 'IMAGE',
        display: 'IMAGE',
        params: {
          content: null,
          width: 460,
          height: 400,
          x: 513,
          y: 211,
          content_id: null
        }
      }
    ]
  }
]
const AiTemplateSelection = ({
  isGeneratingCourse,
  courseTemplateData,
  type,
  onConfirm,
  open,
  close,
  form,
  courrseContent
}) => {
  // Initialize states
  const [templateData, setTemplateData] = useState({
    template_id: '',
    background_color: null,
    opacity: 1,
    background_id: null,
    logo_id: null,
    background_img: null,
    logo_img: null,
    tocs: [courrseContent]
  })

  const [backgroundType, setBackgroundType] = useState('IMAGE')
  const [loading, setLoading] = useState(false)

  // Important! Must use a distinct name from your typo
  const [templateList, setTemplateList] = useState([])

  // Load templates when modal opens
  useEffect(() => {
    if (open) {
      console.log('Modal opened, loading templates...')
      setLoading(true)

      // Simulate async loading (React state updates are asynchronous)
      setTimeout(() => {
        setTemplateList(STATIC_TEMPLATES)

        // Set default template_id if not already set
        if (!templateData.template_id && STATIC_TEMPLATES.length > 0) {
          setTemplateData(prev => ({
            ...prev,
            template_id: STATIC_TEMPLATES[0].template_id
          }))
        }

        setLoading(false)
        console.log('Templates loaded:', STATIC_TEMPLATES)
      }, 100)
    }
  }, [open])

  // Handle courseTemplateData updates
  useEffect(() => {
    if (type && courseTemplateData && courseTemplateData.template_id) {
      // Validate template_id - only allow 1, 2, or 3
      const validTemplateIds = [1, 2, 3]
      const templateId = validTemplateIds.includes(courseTemplateData.template_id)
        ? courseTemplateData.template_id
        : 1 // Default to template 1 if invalid

      setTemplateData(prev => ({
        ...prev,
        background_img: courseTemplateData.background_img,
        opacity: courseTemplateData.opacity || 1,
        logo_img: courseTemplateData.logo_img,
        template_id: templateId,
        background_color: courseTemplateData.background_color,
        background_id: courseTemplateData.background_id,
        logo_id: courseTemplateData.logo_id
      }))

      setBackgroundType(courseTemplateData.background_color ? 'COLOR' : 'IMAGE')
    }
  }, [courseTemplateData, type])

  const onCoverChange = (cover, coverType) => {
    if (coverType === 'bg') {
      setTemplateData(prev => ({
        ...prev,
        background_id: cover.id,
        opacity: 1,
        background_img: cover
      }))
    } else {
      setTemplateData(prev => ({
        ...prev,
        logo_id: cover.id,
        logo_img: cover
      }))
    }
  }

  const onChange = e => {
    setTemplateData(prev => ({
      ...prev,
      background_color: null,
      opacity: 1,
      background_id: null,
      background_img: null
    }))
    setBackgroundType(e.target.value)
  }

  const handleChangeComplete = color => {
    setTemplateData(prev => ({
      ...prev,
      background_color: color.hex
    }))
  }

  const selectTemplate = () => {
    if (!templateData.template_id) {
      message.error('Please select a template layout')
      return
    }
    onConfirm(templateData)
  }

  const handleOpacityChange = value => {
    setTemplateData(prev => ({
      ...prev,
      opacity: value
    }))
  }

  // Function to manually reload templates
  const reloadTemplates = () => {
    console.log('Manually reloading templates...')
    setLoading(true)

    setTimeout(() => {
      setTemplateList(STATIC_TEMPLATES)
      setLoading(false)
      console.log('Templates reloaded, count:', STATIC_TEMPLATES.length)
    }, 100)
  }
  const { t } = useTranslation()

  return (
    <Modal
      title={t('v5:template_selection')}
      visible={open}
      confirmLoading={isGeneratingCourse}
      onOk={selectTemplate}
      cancelText={t('v4:cancel')}
      okText={
        type
          ? courseTemplateData && courseTemplateData.template_id
            ? t('v4:update_course_template')
            : t('v4:add_course_template')
          : t('v4:create_course_now')
      }
      onCancel={close}
      centered
      className="add-new-template"
      maskClosable={false}
    >
      <div className="template-body">
        <Row gutter={[16, 16]} className="mb-8">
          <Col xs={24} md={12}>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Radio.Group onChange={onChange} value={backgroundType}>
                  <Radio.Button value={'IMAGE'}>
                    {t('v4:bg_image')}
                  </Radio.Button>
                  <Radio.Button value={'COLOR'}>
                    {t('v4:bg_color')}
                  </Radio.Button>
                </Radio.Group>
              </Col>
              <Col span={24}>
                {backgroundType === 'IMAGE' ? (
                  <Fragment>
                    <ImageSelect
                      opacity={templateData.opacity}
                      isClearImage
                      form={form}
                      label={'Template Background'}
                      coverInput={templateData.background_img}
                      onClearImage={() => {
                        setTemplateData(prev => ({
                          ...prev,
                          background_id: null,
                          background_img: null,
                          opacity: 1
                        }))
                      }}
                      onCoverChange={cover => {
                        onCoverChange(cover, 'bg')
                      }}
                    />
                    {templateData.background_img && (
                      <Card className="transparency-card">
                        <div className="transparency-card-title">
                          {t('v4:image_transparency')}
                        </div>
                        <div className="transparency-card-slider">
                          <Slider
                            min={0.1}
                            max={1}
                            step={0.1}
                            value={templateData.opacity}
                            onChange={handleOpacityChange}
                            style={{ flex: 1 }}
                          />
                          <span className="transparency-card-slider-value">
                            {templateData.opacity}
                          </span>
                        </div>
                      </Card>
                    )}
                  </Fragment>
                ) : (
                  <Form.Item
                    style={{ marginBottom: 0 }}
                    label={<div>{t('v4:template_bg_color')}</div>}
                    colon={false}
                    required={false}
                  >
                    <BlockPicker
                      color={templateData.background_color || ''}
                      onChangeComplete={handleChangeComplete}
                      colors={colors}
                      styles={{
                        default: {
                          card: {
                            width: '100%'
                          },
                          body: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '4px',
                            borderLeft: '1.5px solid #e3e3e3',
                            borderRight: '1.5px solid #e3e3e3',
                            borderBottom: '1.5px solid #e3e3e3',
                            borderTop: 'none',
                            borderRadius: '0 0 8px 8px'
                          }
                        }
                      }}
                    />
                  </Form.Item>
                )}
              </Col>
            </Row>
          </Col>
          <Col xs={24} md={12}>
            <div className="template-body-title">
              {t('v4:select_template_layout')}
              {templateList.length === 0 && !loading && (
                <span
                  style={{
                    marginLeft: '10px',
                    color: '#1890ff',
                    cursor: 'pointer'
                  }}
                  onClick={reloadTemplates}
                >
                  {t('v4:reload_template')}
                </span>
              )}
            </div>
            <Spin spinning={loading}>
              <div className="template-body-layout">
                {templateList.length > 0 ? (
                  templateList.map((template, index) => (
                    <Card
                      className="template-body-layout-card"
                      key={index}
                      hoverable
                      style={{
                        border:
                          templateData.template_id === template.template_id
                            ? '2px solid #1890ff'
                            : '1px solid #f0f0f0',
                        backgroundColor:
                          templateData.template_id === template.template_id
                            ? '#e6f7ff'
                            : '#fff',
                        cursor: 'pointer'
                      }}
                      onClick={() =>
                        setTemplateData(prev => ({
                          ...prev,
                          template_id: template.template_id
                        }))
                      }
                    >
                      <div className="template-body-layout-card-body">
                        <img
                          src={template.template}
                          alt={`Sample ${template.content_id}`}
                        />
                      </div>
                    </Card>
                  ))
                ) : (
                  <Card
                    className="template-body-layout-card"
                    hoverable
                    style={{
                      border: '1px solid #f0f0f0',
                      backgroundColor: '#fff',
                      cursor: 'pointer'
                    }}
                    onClick={reloadTemplates}
                  >
                    <div className="template-body-layout-card-body">
                      {!loading &&
                        'Template data unavailable. Click to reload.'}
                    </div>
                  </Card>
                )}
              </div>
            </Spin>
          </Col>
        </Row>
      </div>
    </Modal>
  )
}

export default Form.create({ name: 'template_form' })(AiTemplateSelection)
